export const encodeParams = (data = {}, skipEmpty = true) => {
  return Object.keys(data).map((key) => {
    if (!(isEmpty(data[key]) && skipEmpty)) {
      return [key, data[key]].map(encodeParam).join('=')
    }
  }).filter(entry => !!entry).join('&')
}

const encodeParam = (p) => Array.isArray(p) ? p.map(encodeURIComponent).join(',') : encodeURIComponent(p)

export const serialize = (obj, text, startQs) => {
  if (obj.length === 0) return ''
  var str = []
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push('=' + encodeURIComponent(obj[p]))
    }
  }
  const ret = text
  return startQs + ret + str.join('&' + text)
}

export const serializeWithArray = paramsObj => {
  if (paramsObj.length === 0) return ''
  let retStr = ''
  Object.keys(paramsObj).forEach(e => {
    if (Array.isArray(paramsObj[e]) && paramsObj[e].length > 0) {
      const str = []
      paramsObj[e].forEach(r => {
        str.push(`${e}=${encodeURIComponent(r)}`)
      })
      const strJoin = str.join('&')
      retStr += retStr === '' ? strJoin : `&${strJoin}`
    } else {
      if (!isEmpty(paramsObj[e])) {
        const val = encodeURIComponent(paramsObj[e])
        retStr += retStr === '' ? `${e}=${val}` : `&${e}=${val}`
      }
    }
  })
  return retStr
}

const isEmpty = (value) => ((typeof value === 'undefined') || (value === null) || (value === '') || (Array.isArray(value) && value.length === 0))
